import { Navigate, useParams } from 'react-router-dom';

import { useGetMotivoRechazo } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import {  SaveMotivoRechazo} from '../../shared/saveMotivoRechazo';
import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';

export interface UpdateMotivoRechazoPageInterface {}

const UpdateMotivoRechazoPage: React.FC<UpdateMotivoRechazoPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_motivorechazo)
  const { id } = useParams();
  const { data, isLoading } = useGetMotivoRechazo(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_motivo_rechazo) return <Navigate to="/parametrizacion/motivo-rechazo" />;

  return <SaveMotivoRechazo titlePage="Editar Motivo del rechazo" editMotivoRechazo={data.data} />;
};

export default UpdateMotivoRechazoPage;
